import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { StockLocationActions, StockLocationStore, STATUS } from 'Stores/stockLocationStore'
import StockLocationForm from 'Modules/stockLocation/stockLocationForm'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #23282c;
  font-weight: 400;
`

export default class StockLocationEdit extends Component {
  constructor(props) {
    super(props)
    this.stores = [StockLocationStore]
    this.storeKeys = ['status', 'stockLocationDetails']
  }

  componentDidMount() {
    StockLocationActions.getStockLocationDetails(this.props.match.params.StockLocationID)
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('StockLocation Updated', {
        autoClose: 3000,
        onClose: () => {
          StockLocationActions.clearFormToast()
        }
      })
      StockLocationActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('StockLocation Update Failed', {
        autoClose: 3000,
        onClose: () => {
          StockLocationActions.clearFormToast()
        }
      })
      StockLocationActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <StockLocationForm match={this.props.match} />

        <CollapsibleCard startOpen header={<strong>{'Produkter'}</strong>}>
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'ProductID'
              },
              fieldFunctions: {
                elementTitle: e => {
                  return <StyledLink to={`/products/${e.ProductID}`}>{e.elementTitle}</StyledLink>
                }
              },
              fieldStringFunctions: {},
              fieldExportFunctions: {}
            }}
            headers={{
              ProductID: '#',
              elementTitle: 'Produkt',
              totalStock: 'Lagerbeholdning'
            }}
            data={this.state.stockLocationDetails.products}
          />
        </CollapsibleCard>
      </React.Fragment>
    )
  }
}
